import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=1880cb33&scoped=true&"
import script from "./Stock.vue?vue&type=script&lang=js&"
export * from "./Stock.vue?vue&type=script&lang=js&"
import style0 from "./Stock.vue?vue&type=style&index=0&id=1880cb33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880cb33",
  null
  
)

export default component.exports